import { useState } from 'react'

const useMergeState = <T extends object>(initialState: T) => {
  const [state, setState] = useState<T>(initialState)
  const setMergedState = (newState: Partial<T>) => setState(prevState => Object.assign({}, prevState, newState))
  return [state, setMergedState] as const
}

export default useMergeState
